import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { categories } from '../../data/categories';
import { formatPrice } from '../../utils/currency';
export function CategoryGrid() {
  return <section aria-labelledby="categories-heading" className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16" data-id="element-120" data-mp="3qu4suwnd3ya1">
      <div className="flex items-end justify-between gap-4" data-id="element-121" data-mp="3luiicuyx4w4x">
        <h2 id="categories-heading" className="text-2xl font-bold tracking-tight text-ink sm:text-[28px]" data-id="element-122" data-mp="3gybagwmypakc">
          Shop by category
        </h2>
        <Link to="/shop" className="hidden items-center gap-1 text-sm font-semibold text-ink hover:underline sm:inline-flex" data-id="element-123" data-mp="3cyau36gaypan">
          All products <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-124" data-mp="32yjy10c3g28g" />
        </Link>
      </div>

      <ul className="mt-6 grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-6" data-id="element-125" data-mp="165qlatfbc2d7">
        {categories.map(cat => <li key={cat.id} data-id="element-126" data-mp="116x7ezw469ci">
            <Link to={`/shop/${cat.id}`} className="group block" data-id="element-127" data-mp="114ks6uhqqd35">
              <div className="aspect-square overflow-hidden rounded-xl bg-surface" data-id="element-128" data-mp="2179uyn42ntk0">
                <img src={cat.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-129" data-mp="25bhk2lefzbir" />
              </div>
              <h3 className="mt-3 truncate text-[15px] font-semibold text-ink group-hover:underline" data-id="element-130" data-mp="1w9i7q6edgvm5">{cat.name}</h3>
              <p className="mt-0.5 text-sm text-muted" data-id="element-131" data-mp="2jz2p4kuvnktb">From {formatPrice(cat.fromPrice)}</p>
            </Link>
          </li>)}
      </ul>
    </section>;
}